//
//
//
//
//
//
//

  import {mapActions} from 'vuex';
export default {
  name: 'App',

  data(){
    return {
      isXcx:false,
      hasPre:false
    }
    
  },

  watch:{
    '$route'(v){
      console.log(v);
      if(window.history.length<=1){
        this.hasPre=false
      }else{
        this.hasPre=true;
      }
    }
  },

  methods:{
    ...mapActions(['changeCode','changeUserInfo','logout','changeIsXcx']),
    getParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = location.search.substr(1).match(reg);
      if (r != null) return unescape(decodeURI(r[2]));
      return null;
    }
  },
  created() {
    var encodeurl=encodeURIComponent(location.href);
    console.log(this.$route.query);
    var token=this.$cookies.isKey('token');

    

    if(token&&token!=''){
      // this.axios.post('/xcx/Order/testStatus').then(res=>{
        this.axios.post('/xcx/User/index').then(res2=>{
          this.changeUserInfo(res2.data.data);
          // if(res.data.data.code==1){
          //   if(this.$route.path=='/'){
          //     this.$router.replace({name:'tutorial'});
          //   }
          // }else{
          //   this.$router.replace({name:'test'});
          // }
        })
      // })
    }else{
      if(this.getParam('code')){
        this.changeCode(this.$route.query.code).then(res=>{
            // this.$router.replace({name:'login',query:{test:true}});
            this.$cookies.set('token',res);
          })
      }
      // this.$router.push({name:'tutorial'});
      // if(this.$route.query.code&&this.$route.query.state=='gaishi_get_code'){
      //   this.changeCode(this.$route.query.code).then(_=>{
      //     this.$router.replace({name:'login',query:{test:true}});
      //   });
      // }else{
      //   // if(this.getParam('code')&&this.getParam('state')=='gaishi_get_code'){
      //   //   let url=location.protocol+'//'+location.host+'/#/?code='+this.getParam('code')+'&state='+this.getParam('state');
      //   //   location.assign(url);
      //   // }else{
      //     if(process.env.NODE_ENV==='development'){
      //       location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19893d3f30f9f908&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`
      //     }else{
      //       location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19893d3f30f9f908&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`
      //     }
      //   // }

      // }
    }

    //验证token有效性
    let _this=this;
    // setInterval(()=>{
    //   if(this.$store.state.access_token){
    //     this.axios.post('/xcx/Login/loginValid').then(res=>{
          
    //     }).catch(_=>{
    //       if(process.env.NODE_ENV=='development'){
    //         return;
    //       }
    //       this.logout();
    //       this.$vux.alert.show({
    //         title:'提示',
    //         content:'账号已在别处登录',
    //         onHide(){
    //           _this.$router.replace({name:'index'});
    //         }
    //       })
    //       console.log(111);
    //     })
    //   }
    // },5000);

    this.$wechat.ready(()=>{
      this.$wechat.onMenuShareAppMessage({
        title:'红火箭分级阅读',
        desc:'英文分级阅读精读课程',
        imgUrl:`${location.protocol}//${location.hostname}/static/images/xcxtouxiang.png`
      })

      this.$wechat.onMenuShareTimeline({
        title:'红火箭分级阅读',
        desc:'英文分级阅读精读课程',
        imgUrl:`${location.protocol}//${location.hostname}/static/images/xcxtouxiang.png`
      }),

      this.$wechat.getEnv((res)=>{
        this.changeIsXcx(res.miniprogram);
      })
    })

    this.$wechat.miniProgram.getEnv((res)=>{
      console.log(res);
      if(res.miniprogram){
        this.isXcx=true
      }else{
        this.isXcx=false
      }
    })

    

    

    

  }
}



// WEBPACK FOOTER //
// ./src/App.vue